module.exports = __webpack_public_path__ + "static/media/bipolaridade.db078ba9.png";